export function downloadFilename(disposition, fallback) {
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition || '');
  const plain = /filename="?([^";]+)/i.exec(disposition || '');
  let name = encoded?.[1] || plain?.[1] || fallback;
  if (encoded) { try { name = decodeURIComponent(name); } catch (_) { return fallback; } }
  name = name.trim();
  if (!name || !name.toLowerCase().endsWith('.pdf') || /[/\\]|\.\./.test(name)) return fallback;
  return [...name].map((character) => character.charCodeAt(0) < 32 || /[:*?<>|]/.test(character) ? '_' : character).join('');
}
